import { render, staticRenderFns } from "./SelectProfileTypeForPrefilledDocumentModal.vue?vue&type=template&id=9a0ce90c&scoped=true&"
import script from "./SelectProfileTypeForPrefilledDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./SelectProfileTypeForPrefilledDocumentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0ce90c",
  null
  
)

export default component.exports